import { map } from 'lodash-es'

const transformer = function (origin, defs) {
  const value = map(origin, (line) => {
    return (line && line.title) || '未找到点位'
  })

  return {
    render: 'text',
    origin,
    value: value.join('-'),
    defs,
  }
}

export default transformer
